import React from 'react';
import { observer } from 'mobx-react-lite';

import { useSubmissionFormStore } from 'widget/hooks/useSubmissionFormStore';

import styles from './ContactFormBlock.module.scss';
import ContactFormItem from './ContactFormItem';

const ContactFormBlock: React.FC = () => {
  const submissionFormStore = useSubmissionFormStore();

  if (!submissionFormStore || submissionFormStore.contactFields.length === 0) {
    return null;
  }

  return (
    <div className={styles['contact-form']}>
      {submissionFormStore.contactFields.map((field) => (
        <ContactFormItem
          key={field.type}
          field={field}
          value={submissionFormStore.getFieldValue(field.type)}
          error={submissionFormStore.getFieldError(field.type)}
          disabled={submissionFormStore.isInputDisabled}
          onChangeField={submissionFormStore.setFieldValue}
          onBlurField={submissionFormStore.setFieldBlur}
        />
      ))}
    </div>
  );
};

export default observer(ContactFormBlock);
